module.exports = __webpack_public_path__ + "homeStatic/img/img03.8d74b16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/img03.png
// module id = A2+d
// module chunks = 1